<div class="journal-review">
  <fieldset class="rms-fieldset filters">
    <legend>Journals</legend>
    <div class="filter-grid">
      <rms-select name="Status" label="Status" [options]="StatusOptions" [(ngModel)]="Filters.Status" (ngModelChange)="load()"></rms-select>
      <rms-select name="PeriodID" label="Period" [includeSearch]="true" [options]="PeriodOptions" [(ngModel)]="Filters.PeriodID" (ngModelChange)="load()"></rms-select>
      <rms-input name="SearchText" label="Search" placeholder="Journal #, reason, source or preparer" [(ngModel)]="Filters.SearchText" (keyup.enter)="load()"></rms-input>
    </div>
    <p class="muted">Journals are prepared as drafts, submitted for review, and written to the ledger when approved and posted. Deleted drafts are in the Recycle Bin tab.</p>
  </fieldset>

  @if (Loading) {
  <p class="muted" role="status">Loading journals…</p>
  }

  <rms-table [data]="Rows"
             [columns]="Columns"
             [HeaderButtons]="Buttons"
             [clickableRow]="true"
             (onRowClick)="open($event.row)"
             tableId="ledger-journals">
  </rms-table>
</div>
